import { ACTION_TYPES } from '../../../constants/index';
import { getDecryptedCookie } from '../../../utils';

const initialState = {
    isAuthenticated: getDecryptedCookie('bid') ? true : false,
    token: getDecryptedCookie('token')
};

const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case ACTION_TYPES.AUTH:
            return {
                ...state,
                isAuthenticated: action.payload.isAuthenticated,
                token: action.payload.token
            };
        default:
            return state;
    }
};

export default authReducer;
